import TSFile from './TSFile';

export default class TSDokument extends TSFile {


    deserialize(restObject: any): TSFile {
        super.deserialize(restObject);
        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);
        return restObject;
    }
}





// WEBPACK FOOTER //
// ./src/app/models/TSDokument.ts